import './App.css';
import { BrowserRouter } from "react-router-dom"
import Routers from './Routes';
// import { AppProvider } from './Context/Context';




function App() {

  return (
   
     <>
    
      <>
     {/* <AppProvider> */}
    <div className="">
      <BrowserRouter>
        <Routers />
      </BrowserRouter>
      
    </div>
    {/* </AppProvider> */}
    </>
  
    </>
  );
}

export default App;
